import React from 'react'
import {withRouter } from 'react-router-dom'

const LoginForm = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="form-input">
                <label>Email Address</label>
                <input type="email" name="email" value={props.email} onChange={props.onChange} />
                <span className="error">{props.errors.email}</span>
            </div>
            <div className="form-input">
                <label>Password</label>
                <input type="password" name="password" value={props.password} onChange={props.onChange} />
                <span className="error">{props.errors.password}</span>
            </div>
            <div className="actions">
                <button className={props.processing ? 'disabled' : ''}>Log In</button>
            </div>
        </form>
    )
}

export default withRouter(LoginForm)